"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const filter_store_1 = require("./filter-store");
exports.filterServiceDefinition = {
    id: 'filter-service',
    dependencies: {
        featureServices: {
            's2:history': '^2.0.0',
        },
    },
    create: ({ featureServices }) => {
        const { history } = featureServices['s2:history'];
        const filterStore = new filter_store_1.FilterStore(history);
        return {
            '1.1.0': (consumerId) => ({
                featureService: {
                    get filters() {
                        return filterStore.get();
                    },
                    add: (filterType, value) => {
                        filterStore.update({ type: 'add', filterType, value, consumerId });
                    },
                    remove: (filterType, value) => {
                        filterStore.update({ type: 'remove', filterType, value, consumerId });
                    },
                    reset: () => {
                        filterStore.update({ type: 'reset', consumerId });
                    },
                    listen: (listener) => filterStore.listen(listener),
                },
            }),
        };
    },
};
//# sourceMappingURL=index.js.map